// extracted by mini-css-extract-plugin
module.exports = {"container":"mobileTabBar_container__27P0u"};